import React, { useState, useEffect } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import "./WallentPendding.css";
import { fetchAllPenddingTxns, penddingFundLoadUpdate } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "./Modal";
import Spinner from "../../../screens/Spin/Spinner";

const PenddingForm = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [modalData, setModalData] = useState({ isOpen: false, tnxId: null, status: null });

  const getWalletData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchAllPenddingTxns(token);
      setTableData(response.data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWalletData();
  }, [token]);

  const handleAction = (tnxId, status) => {
    setModalData({ isOpen: true, tnxId, status });
  };

  const handleConfirm = async () => {
    setModalData({ isOpen: false, tnxId: null, status: null });
    setIsLoading(true); 
    try {
      const payload = {
        status: modalData.status,
        tnxId: modalData.tnxId,
      };
      const res = await penddingFundLoadUpdate(token, payload);
      toast.success(res.message || "Updated successfully!");
      await getWalletData();
    } catch (err) {
      toast.error("Failed to update status.");
    } finally {
      setModalData({ isOpen: false, tnxId: null, status: null });
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setModalData({ isOpen: false, tnxId: null, status: null });
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 300); // Flash spinner
  };
  return (
    <div className="pendding-report-table-container">
      <h2 className="pendding-report-table-title">Wallet Pending</h2>
      <table className="pendding-table">
        <thead>
          <tr>
            <th>Deposit Amount</th>
            <th>Merchant Name</th>
            <th>Payment Mode</th>
            <th>UTR</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="9">Loading...</td></tr>
          ) : tableData?.length > 0 ? (
            tableData.map((transaction, index) => (
              <tr key={index}>
                <td>₹ {Number(transaction.depositAmount).toFixed(2)|| "0"}</td>
                <td>{transaction.User_FundLoad_userIdToUser?.name || "-"}</td>
                <td>{transaction.paymentMode || "-"}</td>
                <td>{transaction.utr || "-"}</td>
                <td>{transaction.status || "-"}</td>
                <td>
                  <button
                    className="approve-btn"
                    onClick={() => handleAction(transaction.tnxId, "SUCCESS")}
                  >
                    <FcApprove size={32} />
                  </button>
                  <button
                    className="approve-btn"
                    onClick={() => handleAction(transaction.tnxId, "FAILED")}
                  >
                    <FcDisapprove size={32} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="9">No Pending Fund Load found.</td></tr>
          )}
        </tbody>
      </table>

      {modalData.isOpen && (
        <Modal
          message={`Are you sure you want to this Fund Load Tnx as ${modalData.status}?`}
          onConfirm={handleConfirm}
          onCancel={() => setModalData({ isOpen: false, tnxId: null, status: null })}
        />
      )}
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default PenddingForm;
